<template>
  <b-sidebar
    id="sidebar-cancel-student"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Cancel Student') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="cancelStudent">
          <b-form-group
            :label="$t('File')"
            label-for="file"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File')"
              rules="required|file-size:10"
            >
              <b-form-file
                v-model="file"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
                @change="handleFile"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Confirm') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BButton, BFormGroup, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, localize, ValidationProvider } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    BFormFile,
    BFormGroup,
    ValidationObserver,
    BSidebar,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      base64: null,
      file: null,
    }
  },
  computed: {
    applyDocument: {
      get() {
        return this.$store.state.applyDocument.applyDocument
      },
      set(data) {
        this.$store.commit('applyDocument/UPDATE', data)
      },
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    handleFile(e) {
      // eslint-disable-next-line prefer-destructuring
      this.base64 = e.target.files[0]
    },
    clear(hide) {
      this.$refs.cancelStudent.reset()
      this.base64 = null
      this.file = null
      hide()
    },
    submit(hide) {
      this.$refs.cancelStudent.validate().then(success => {
        if (success) {
          this.$removeSwal(this, {
            id: this.applyDocument.id,
            file: this.base64,
          }, 'applyDocument/changeBannedFile', this.refetchData, {
            confirmButtonText: 'Yes, cancel student!',
            successTitle: 'Cancel student!',
            successText: 'Successfully completed',
            errorText: 'There was an error in successful execution',
          })
          hide()
        }
      })
    },
    refetchData() {
      this.$emit('refetchData')
    },
  },
}
</script>
